import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Row, Table } from 'antd';
import { fetchAnalyticsReportList, fetchAnalyticsReport } from './actions';
import FullPageLoading from '../../component/FullPageLoading';
// import s from './Analytics.module.scss';
import s from './AnalyticsReport.module.scss';

class AnalyticsReportList extends React.Component {
  columns = [
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      sorter: (a, b) => a.title.localeCompare(b.title),
    },
    {
      title: 'Is Active',
      dataIndex: 'active',
      key: 'active',
      align: 'center',
      filters: [
        {
          text: 'Yes',
          value: true,
        },
        {
          text: 'No',
          value: false,
        },
      ],
      filterMultiple: false,
      onFilter: (value, record) => record.active === value,
      render: (value, record) => {
        if (!value) {
          return <span style={{ color: 'red' }}>No</span>;
        }
        return <span style={{ color: 'green' }}>Yes</span>;
      },
    },
    {
      title: 'Is Default',
      dataIndex: 'is_default',
      key: 'is_default',
      align: 'center',
      filters: [
        {
          text: 'Yes',
          value: true,
        },
        {
          text: 'No',
          value: false,
        },
      ],
      filterMultiple: false,
      onFilter: (value, record) => record.is_default === value,
      render: (value, record) => {
        if (!value) {
          return <span style={{ color: 'red' }}>No</span>;
        }
        return <span style={{ color: 'green' }}>Yes</span>;
      },
    },
    {
      title: 'Database',
      dataIndex: 'database',
      key: 'database',
      align: 'center',
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
    },
    {
      title: 'Updated At',
      dataIndex: 'updated_at',
      key: 'updated_at',
      sorter: (a, b) => new Date(a.updated_at) - new Date(b.updated_at),
    },
  ];

  componentDidMount() {
    // eslint-disable-next-line no-shadow
    const { fetchAnalyticsReportList } = this.props;
    fetchAnalyticsReportList();
  }

  onToggleQuery = obj => (c, e) => {
    e && e.stopPropagation();
    const { updateAnalyticsQuery } = this.props;
    updateAnalyticsQuery({
      id: obj.id,
      isActive: !obj.isActive,
    });
  };

  handleCreate = () => {
    const { history, clearQueryForm } = this.props;
    // clearQueryForm();
    history.push('/analytics-reports/new');
  };

  onRowClick = record => {
    const { history } = this.props;
    // fetchAnalyticsReport(record.id);
    history.push(`/analytics-reports/edit/${record.id}`);
  };

  render() {
    const { reportList = {} } = this.props;
    const { loading, reports } = reportList;
    return (
      <div className={`ck-card ${s['anaytics-query-table']}`}>
        <Row type="flex" justify="space-between">
          <h3>Analytics Reports</h3>
          <Button type="primary" onClick={this.handleCreate}>
            Create
          </Button>
        </Row>
        <div>
          {loading && <FullPageLoading fontSize={30} />}
          {!loading && (
            <Table
              dataSource={reports}
              columns={this.columns}
              rowKey={record => record.id}
              onRow={(record, rowIndex) => ({
                onClick: () => this.onRowClick(record, rowIndex),
              })}
              className={`${s['query-table']}`}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ analyticsReport }) => {
  const { reportList } = analyticsReport;
  return {
    reportList,
  };
};

const mapDispatchToProps = {
  fetchAnalyticsReportList,
  fetchAnalyticsReport,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AnalyticsReportList)
);
